import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Settings } from "@/interfaces";
import { baseUrl, settingId } from "@/consts";
import { SettingsContextProps } from "./context";
import { formatAxiosError } from "@/utils";
import { SettingsHelper } from "@/helpers";

export const useSettingsContextController = (): SettingsContextProps => {
  const [settingsValue, setSettingsValue] = useState<Settings | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState(false);

  const setSettings = useCallback(
    (settings?: Settings) => {
      setSettingsValue(settings);
    },
    [setSettingsValue]
  );

  const loadSettings = useCallback(() => {
    setIsLoading(true);

    return axios
      .get(`${baseUrl.SETTING}/${settingId}`)
      .then((response) => {
        setSettingsValue(SettingsHelper.fromDto(response?.data));
        return response.data;
      })
      .catch((error) => {
        // Don't show alert for 401 errors (user not logged in yet)
        if (error.response?.status !== 401) {
          alert(`Settings: ${formatAxiosError(error)}`);
        }
        throw error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    // Try to load settings on mount
    // If this fails with 401, it will be retried after login
    loadSettings().catch(() => {
      // Silently fail - will be loaded after login
    });
  }, [loadSettings]);

  return { settings: settingsValue, setSettings, loadSettings };
};
